import React from "react";
import {
  TextField,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Table,
  Paper,
} from "@mui/material";

function InvoiceDetails({ invoiceData }) {
  return (
    <>
      <TableContainer component={Paper} style={{ width: "48%" }}>
        <Table size="small">
          <TableHead style={{ textTransform: "uppercase" }}>
            <TableRow>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Customer
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Name"
                  variant="standard"
                  value={invoiceData.name}
                  style={{ width: "100%" }}
                  disabled
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Company Name"
                  variant="standard"
                  disabled
                  value={invoiceData.companyName}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Email Address"
                  variant="standard"
                  type="email"
                  disabled
                  value={invoiceData.email}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Address"
                  variant="standard"
                  disabled
                  value={invoiceData.address}
                  style={{ width: "100%" }}
                  multiline
                  rows={2}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <TableContainer component={Paper} style={{ width: "48%" }}>
        <Table size="small">
          <TableHead style={{ textTransform: "uppercase" }}>
            <TableRow>
              <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
                Quote description
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Truck Used"
                  variant="standard"
                  disabled
                  value={invoiceData.truck}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Origin"
                  variant="standard"
                  disabled
                  value={invoiceData.origin}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Destination"
                  variant="standard"
                  disabled
                  value={invoiceData.destination}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Distance (miles)"
                  variant="standard"
                  disabled
                  value={invoiceData.distance}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <TextField
                  required
                  label="Transit time"
                  variant="standard"
                  disabled
                  value={invoiceData.transitTime}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default InvoiceDetails;
